module.exports = __webpack_public_path__ + "img/dsci0093.45f612fe.jpg";